module.exports = {
	"title": "CSS3 Cursors: grab & grabbing",
	"description": "Support for `grab`, `grabbing` values for the CSS3 `cursor` property.",
	"spec": "http://www.w3.org/TR/css3-ui/#cursor",
	"status": "cr",
	"links": [
		{
			"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/cursor",
			"title": "MDN Documentation"
		}
	],
	"bugs": [],
	"categories": [
		"CSS3"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"5.5": "n"
		},
		"edge": {
			"12": "n",
			"13": "n",
			"14": "n"
		},
		"firefox": {
			"2": "y x",
			"3": "y x",
			"4": "y x",
			"5": "y x",
			"6": "y x",
			"7": "y x",
			"8": "y x",
			"9": "y x",
			"10": "y x",
			"11": "y x",
			"12": "y x",
			"13": "y x",
			"14": "y x",
			"15": "y x",
			"16": "y x",
			"17": "y x",
			"18": "y x",
			"19": "y x",
			"20": "y x",
			"21": "y x",
			"22": "y x",
			"23": "y x",
			"24": "y x",
			"25": "y x",
			"26": "y x",
			"27": "y",
			"28": "y",
			"29": "y",
			"30": "y",
			"31": "y",
			"32": "y",
			"33": "y",
			"34": "y",
			"35": "y",
			"36": "y",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"44": "y",
			"45": "y",
			"46": "y",
			"47": "y",
			"48": "y",
			"49": "y",
			"50": "y",
			"51": "y",
			"52": "y",
			"53": "y",
			"3.5": "y x",
			"3.6": "y x"
		},
		"chrome": {
			"4": "y x",
			"5": "y x",
			"6": "y x",
			"7": "y x",
			"8": "y x",
			"9": "y x",
			"10": "y x",
			"11": "y x",
			"12": "y x",
			"13": "y x",
			"14": "y x",
			"15": "y x",
			"16": "y x",
			"17": "y x",
			"18": "y x",
			"19": "y x",
			"20": "y x",
			"21": "y x",
			"22": "y x",
			"23": "y x",
			"24": "y x",
			"25": "y x",
			"26": "y x",
			"27": "y x",
			"28": "y x",
			"29": "y x",
			"30": "y x",
			"31": "y x",
			"32": "y x",
			"33": "y x",
			"34": "y x",
			"35": "y x",
			"36": "y x",
			"37": "y x",
			"38": "y x",
			"39": "y x",
			"40": "y x",
			"41": "y x",
			"42": "y x",
			"43": "y x",
			"44": "y x",
			"45": "y x",
			"46": "y x",
			"47": "y x",
			"48": "y x",
			"49": "y x",
			"50": "y x",
			"51": "y x",
			"52": "y x",
			"53": "y x",
			"54": "y x",
			"55": "y x",
			"56": "y x",
			"57": "y x"
		},
		"safari": {
			"4": "y x",
			"5": "y x",
			"6": "y x",
			"7": "y x",
			"8": "y x",
			"9": "y x",
			"10": "y x",
			"3.1": "y x",
			"3.2": "y x",
			"5.1": "y x",
			"6.1": "y x",
			"7.1": "y x",
			"9.1": "y x",
			"TP": "y x"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "y",
			"15": "y x",
			"16": "y x",
			"17": "y x",
			"18": "y x",
			"19": "y x",
			"20": "y x",
			"21": "y x",
			"22": "y x",
			"23": "y x",
			"24": "y x",
			"25": "y x",
			"26": "y x",
			"27": "y x",
			"28": "y x",
			"29": "y x",
			"30": "y x",
			"31": "y x",
			"32": "y x",
			"33": "y x",
			"34": "y x",
			"35": "y x",
			"36": "y x",
			"37": "y x",
			"38": "y x",
			"39": "y x",
			"40": "y x",
			"41": "y x",
			"42": "y x",
			"43": "y x",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "y",
			"12.1": "y"
		},
		"ios_saf": {
			"8": "n",
			"10": "n",
			"3.2": "n",
			"4.0-4.1": "n",
			"4.2-4.3": "n",
			"5.0-5.1": "n",
			"6.0-6.1": "n",
			"7.0-7.1": "n",
			"8.1-8.4": "n",
			"9.0-9.2": "n",
			"9.3": "n"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "n",
			"4": "n",
			"53": "n",
			"2.1": "n",
			"2.2": "n",
			"2.3": "n",
			"4.1": "n",
			"4.2-4.3": "n",
			"4.4": "n",
			"4.4.3-4.4.4": "n"
		},
		"bb": {
			"7": "y x",
			"10": "y x"
		},
		"op_mob": {
			"10": "n",
			"11": "n",
			"12": "n",
			"37": "n",
			"11.1": "n",
			"11.5": "n",
			"12.1": "n"
		},
		"and_chr": {
			"53": "n"
		},
		"and_ff": {
			"49": "n"
		},
		"ie_mob": {
			"10": "n",
			"11": "n"
		},
		"and_uc": {
			"11": "n"
		},
		"samsung": {
			"4": "n"
		}
	},
	"notes": "",
	"notes_by_num": {},
	"usage_perc_y": 38.8,
	"usage_perc_a": 0,
	"ucprefix": false,
	"parent": "",
	"keywords": "cursors, pointers, grab, grabbing",
	"ie_id": "",
	"chrome_id": "",
	"firefox_id": "",
	"webkit_id": "",
	"shown": false
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css3-cursors-grab.json
 ** module id = 439
 ** module chunks = 0
 **/